import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { generatePath } from "react-router";

import UserBadge from "~/modules/user/components/UserBadge";
import RenderIf, { Payload } from "~/shared/components/RenderIf";
import { Shared_UserFragment } from "~/shared/models/User.fragment.generated";

type Props = {
    title: string;
    titleSlot?: ReactNode;
    user: Payload<Shared_UserFragment>;
};

export default function MapEditorFeatureDetailTitle({ title, user, titleSlot: status }: Props) {
    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h4">{title}</Typography>
                {status}
            </Stack>
            <RenderIf
                payload={user}
                render={user => (
                    <UserBadge
                        names={[user.firstName, user.lastName]}
                        profilePicture={user.profilePictureMedia?.url}
                        showName
                        linkTo={generatePath("/admin/users/:userId", {
                            userId: user.id,
                        })}
                    />
                )}
            />
        </>
    );
}
